

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";

import 'bootstrap';


import navigation from './navigation/navigation';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    AOS.init({
        once: true,
        disable: 'mobile',
        duration: 1000,
        anchorPlacement: 'top'
    });

    navigation();

    $("a[href*='#']").on('click', function(e) {
        let href = $(this).attr('href'),
              checkAnchor = new RegExp("^#.+");

        if (checkAnchor.test(href)) href = location.pathname + href;

        if (href.indexOf(location.pathname) !== -1 && href.indexOf('team-modal-') === -1) {

            if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'')
                || location.hostname === this.hostname) {

                let target = $(this.hash);
                target = target.length ? target : $('[id=' + this.hash.slice(1) +']');
                if (target.length) {
                    e.preventDefault();
                    $('html,body').animate({
                        scrollTop: target.offset().top
                    }, {
                        duration: 750,
                        complete: function(){
                            if (href.indexOf('#top') === -1) {
                                $('.header').addClass('header-hidden');
                            }
                        }
                    });
                }
            }
        }
    });

});
